// extracted by mini-css-extract-plugin
export default {"blocks":"VideoPage_blocks__mDHKP"};